export default __webpack_public_path__ + "static/media/a2.e1d45b8e.png";